import {useMemo} from 'react';
import {Store} from '../models/store.model';
import DefaultCoordinateTransformerService from '../../../Services/map/CoordinateTransformerService';

export const useCoordinateValidation = () => {
  const coordinateService = DefaultCoordinateTransformerService.getInstance();

  const validateStore = useMemo(() => {
    return (store: Store): boolean => {
      return coordinateService.isValidCoordinatePair(store.latitude, store.longitude);
    };
  }, [coordinateService]);

  const validateMarketer = useMemo(() => {
    return (marketer: any): boolean => {
      return coordinateService.isValidCoordinatePair(marketer.latitude, marketer.longitude);
    };
  }, [coordinateService]);

  const filterValidStores = useMemo(() => {
    return (stores: Store[]): Store[] => {
      return stores.filter(store => {
        const isValid = validateStore(store);
        if (!isValid) {
          coordinateService.validateAndLogCoordinates(store, 'StoreMap');
        }
        return isValid;
      });
    };
  }, [validateStore, coordinateService]);

  const filterValidMarketers = useMemo(() => {
    return (marketers: any[]): any[] => {
      return marketers.filter(marketer => {
        const isValid = validateMarketer(marketer);
        if (!isValid) {
          coordinateService.validateAndLogCoordinates(marketer, 'StoreMap');
        }
        return isValid;
      });
    };
  }, [validateMarketer, coordinateService]);

  return {
    validateStore,
    validateMarketer,
    filterValidStores,
    filterValidMarketers
  };
};
